<template>
  <v-card>
    <v-card-title>{{ $t("pages.helpdesk.rules.note") }}</v-card-title>
      <v-card-text>
        <div>
          <i18n path="pages.helpdesk.rules.rule_1" tag="div">
            <template #faq>
              <router-link :to="{ name: 'faq' }" class="primary--text">
                {{ $t("pages.helpdesk.rules.faq") }}
              </router-link>
            </template>
          </i18n>
        </div>
        <div>{{ $t("pages.helpdesk.rules.rule_2") }}</div>
        <div>{{ $t("pages.helpdesk.rules.rule_3") }}</div>
        <div>
          <i18n path="pages.helpdesk.rules.rule_4" tag="div">
            <template #email>
              <a :href="`mailto:${supportEmail}`" class="primary--text">{{ supportEmail }}</a>
            </template>
          </i18n>
        </div>
        <div>
          <i18n path="pages.helpdesk.rules.rule_5" tag="div">
            <template #email>
              <a :href="`mailto:${financeEmail}`" class="primary--text">{{ financeEmail }}</a>
            </template>
          </i18n>
        </div>
        <div>{{ $t("pages.helpdesk.rules.rule_6") }}</div>
      </v-card-text>
  </v-card>
</template>

<script>
import { SUPPORT_EMAIL, SUPPORT_FINANCE_EMAIL } from "@/constants/supportContacts";

export default {
  name: "HelpdeskRules",
  computed: {
    financeEmail() {
      return SUPPORT_FINANCE_EMAIL;
    },
    supportEmail() {
      return SUPPORT_EMAIL;
    }
  }
};
</script>
